<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.25 5.5L13 9.25M13 9.25L9.25 13M13 9.25H4C3.20435 9.25 2.44129 8.93393 1.87868 8.37132C1.31607 7.80871 1 7.04565 1 6.25V1" stroke="#6782F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>